import * as THREE from 'three/webgpu';

/**
 * 沿对象父级链解析其所属 Three.js 场景。
 *
 * 设计说明：
 * 1. 草图控制点的“几何关联”不等于“已经挂载到场景”，内部计算点可能没有任何父节点；
 * 2. 拖拽留影只能为已经进入场景树的对象创建视觉副本；
 * 3. 统一返回可空结果，让调用方自行决定跳过内部点还是抛出明确错误。
 *
 * @param source 待解析的 Three.js 对象。
 * @returns 所属场景；对象未挂载到场景时返回 `null`。
 */
export function resolveObject3DSceneAncestor(source: THREE.Object3D): THREE.Scene | null {
    let current: THREE.Object3D | null = source;

    while (current) {
        if (current instanceof THREE.Scene) {
            return current;
        }
        current = current.parent;
    }

    return null;
}
